module.exports = __webpack_public_path__ + "static/media/google_maps_directions.8d8a680a.png";